import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-change-organization-parent',
  templateUrl: './change-organization-parent.component.html',
  styleUrls: ['./change-organization-parent.component.css']
})
export class ChangeOrganizationParentComponent implements OnInit {
  public companies = [];
  public index: number;
  public title: String;
  public parent: any;
  public selectedParent;
  public companyName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeOrganizationParentComponent>,
  ) { }

  ngOnInit() {
    if ( this.data !== null) {
      this.title = this.data.title;
      this.index = this.data.index;
      this.companies = Object.assign([] , this.data.companies);
      this.companyName = this.companies[this.index].company.companyName;
      this.parent = this.companies.splice(this.index, 1);
      }
  }
  cancel() {
    this.dialogRef.close('Cancel');
  }

  proceed() {
    this.dialogRef.close({
      selected: this.parent
    });
  }

}
